import {RATING_LABEL, fmtMs, fmtCls} from "./ratings";

/**
 * Dựng dữ liệu xuất Excel/PDF cho 1 báo cáo PageSpeed (result.strategies.{mobile,desktop}).
 * Dùng chung cho trang kiểm tra và modal lịch sử. Gate theo gói nằm ở ExportButtons —
 * hàm này thuần dữ liệu, gọi LÚC bấm nút để lấy kết quả đang hiển thị.
 */

const CATEGORIES = [
	{key: 'performance', label: 'Hiệu suất'},
	{key: 'accessibility', label: 'Trợ năng'},
	{key: 'best-practices', label: 'Thực hành tốt'},
	{key: 'seo', label: 'SEO'},
];

const LAB_METRICS = [
	{key: 'lcp', label: 'LCP', fmt: fmtMs},
	{key: 'cls', label: 'CLS', fmt: fmtCls},
	{key: 'tbt', label: 'TBT', fmt: fmtMs},
	{key: 'fcp', label: 'FCP', fmt: fmtMs},
	{key: 'si', label: 'Speed Index', fmt: fmtMs},
];

const FIELD_METRICS = [
	{key: 'lcp', label: 'LCP', fmt: fmtMs},
	{key: 'inp', label: 'INP', fmt: fmtMs},
	{key: 'cls', label: 'CLS', fmt: fmtCls},
	{key: 'fcp', label: 'FCP', fmt: fmtMs},
];

const MF_STATUS = {pass: 'Đạt', fail: 'Chưa đạt', na: 'Không có dữ liệu'};

const ratingText = (r) => RATING_LABEL[r] || '';

/** Các dòng [Chỉ số, Giá trị, Đánh giá] của 1 strategy: điểm 4 hạng mục + Lab + CrUX + di động. */
function metricRows(strat, isMobile) {
	const rows = [];

	CATEGORIES.forEach(({key, label}) => {
		const item = strat.scores?.[key] || {};
		rows.push([`Điểm ${label}`, item.score ?? '—', ratingText(item.rating)]);
	});

	LAB_METRICS.forEach(({key, label, fmt}) => {
		const m = strat.lab?.[key];
		rows.push([`Lab · ${label}`, m ? fmt(m.value) : '—', ratingText(m?.rating)]);
	});

	if (strat.field?.available) {
		FIELD_METRICS.forEach(({key, label, fmt}) => {
			const m = strat.field?.[key];
			rows.push([`CrUX · ${label}`, m ? fmt(m.value) : '—', ratingText(m?.rating)]);
		});
	}

	if (isMobile && strat.mobile_friendly?.available) {
		(strat.mobile_friendly.checks || []).forEach((c) => {
			rows.push([`Di động · ${c.label}`, c.display || MF_STATUS[c.status] || '—', c.message || '']);
		});
	}

	return rows;
}

/** Các dòng cơ hội cải thiện [Nhóm, Vấn đề, Tiết kiệm, Cách khắc phục]. */
function oppRows(strat) {
	return (strat.opportunities || []).map((o) => [
		o.group || 'Khác',
		o.title,
		o.savingsMs > 0 ? `~${fmtMs(o.savingsMs)}` : (o.display || ''),
		o.fix || '',
	]);
}

export function buildPsiExport(result) {
	let host = 'url';
	try { host = new URL(result.url).hostname; } catch (e) { /* URL lạ → giữ mặc định */ }

	const strategies = [
		{label: 'Mobile', strat: result.strategies?.mobile, isMobile: true},
		{label: 'Desktop', strat: result.strategies?.desktop, isMobile: false},
	].filter((s) => s.strat);

	const buildExcel = () => strategies.map(({label, strat, isMobile}) => ({
		name: label,
		aoa: [
			['Chỉ số', 'Giá trị', 'Đánh giá'],
			...metricRows(strat, isMobile),
			[],
			['Nhóm', 'Cơ hội cải thiện', 'Tiết kiệm', 'Cách khắc phục'],
			...oppRows(strat),
		],
	}));

	const buildPdf = () => ({
		title: 'Báo cáo PageSpeed / Core Web Vitals',
		subtitle: result.url,
		sections: strategies.flatMap(({label, strat, isMobile}) => [
			{heading: `Chỉ số — ${label}`, columns: ['Chỉ số', 'Giá trị', 'Đánh giá'], rows: metricRows(strat, isMobile)},
			...((strat.opportunities || []).length > 0 ? [{
				heading: `Cơ hội cải thiện — ${label}`,
				columns: ['Nhóm', 'Vấn đề', 'Tiết kiệm'],
				rows: oppRows(strat).map((r) => r.slice(0, 3)),
			}] : []),
		]),
	});

	return {filename: `bao-cao-pagespeed-${host}`, buildExcel, buildPdf};
}
